var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap justify-content-between"},[_c('Talk',{staticClass:"mb-1",attrs:{"userID":_vm.userId}}),_c('TalkSummary',{attrs:{"userId":_vm.userId,"periods":_vm.periods}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }